import React from 'react';

import Spinner from '@adsk/alloy-react-progress-ring';

import { ContentLoading } from './styles';

/**
 * Props types for LoaderNode component.
 */
type LoaderNodeProps = {
  height: number;
  showSkeletonLoading?: boolean;
  onMounted?: () => void;
  onUnmounted?: () => void;
};

/**
 * LoaderNode is a component that displays a skeleton loading or a spinner loading.
 *
 * @param showSkeletonLoading - Whether to show the skeleton loading.
 * @param height - The height of the node.
 * @param onMounted - The function to call when the node is mounted.
 * @param onUnmounted - The function to call when the node is unmounted.
 */
const LoaderNode = ({ showSkeletonLoading, height, onMounted, onUnmounted }: LoaderNodeProps) => {
  const contentHeight = Math.round(height / 3) || 12;

  React.useEffect(() => {
    onMounted?.();

    return () => {
      onUnmounted?.();
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      {showSkeletonLoading ? (
        <ContentLoading $height={contentHeight}>
          <rect x="0" y="0" rx="6" ry="6" width="50%" height={contentHeight} />
        </ContentLoading>
      ) : (
        <Spinner size="small" />
      )}
    </>
  );
};

LoaderNode.displayName = 'LoaderNode';

export default LoaderNode;
